/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { Link, withRouter, useLocation } from "react-router-dom";
import InputBox from "Components/Register/InputBox";
import Button from "Components/common/Button";
import { Utils } from "Utils/utils";
import { MP_EVENT, GOOGLE_CLIENT_ID, CLIENT_URL } from "Static/constant";
import makeApi, { URLS } from "Utils/apiURL";
import { captchaStoreValue } from "Stores/captcha";
import { loginValidate } from "Utils/commonAPI";
import AlertBox, { alertStore } from "Components/common/AlertBox";
import GoogleImg from "Assets/logo/google.webp";

const LoginComponent = observer((props = {}) => {
  let location = useLocation();
  let queryParams = Utils.getQueryParams(location.search);
  let pluginUser = queryParams?.get("source")?.includes("plugin");
  let homeRouteUser = queryParams?.get("source")?.includes("homepage");

  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState({
    password: "",
    showPassword: false,
  });
  const [emailErr, setEmailErr] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [loader, setLoader] = useState(false);
  const authPopupRef = useRef(null);

  const checkUserHasTeam = async () => {
    return await loginValidate();
  };

  const checkPluginLogin = () => {
    if (pluginUser) {
      Utils.mixpanelTrack("User Login", {
        userEmail,
        pageType: `Chrome Salesgear Login`,
        source: "PLUGIN",
      });
      props.history.push(`/pluginSuccess${location.search}`);
    }
  };

  const checkHomerouteUser = () => {
    if (homeRouteUser) {
      Utils.mixpanelTrack("User Login", {
        userEmail,
        pageType: `Chrome Salesgear Login`,
        source: "HOMEROUTE",
      });
      props.history.push("/pricing");
    }
  };

  const login = async token => {
    try {
      let isEmailValid = Utils.emailValidate(userEmail?.trim() || "");
      let isPasswordValid = userPassword?.password;
      if (isEmailValid && isPasswordValid) {
        const config = {
          url: URLS.loginUser,
          data: {
            email: userEmail?.trim() || "",
            password: userPassword?.password || "",
            token,
          },
          method: "POST",
        };
        let response = await makeApi(config);
        Utils.mixpanelTrack(MP_EVENT.LOGIN_CLICKED, {
          pageType: "Login",
          userEmail,
        });
        switch (response?.data?.success) {
          case "true":
            await checkUserHasTeam();
            checkPluginLogin();
            checkHomerouteUser();
            break;
          default:
            setErrMsg("Please check your email address or password");
            setLoader(false);
            break;
        }
      } else if (!isEmailValid) {
        setEmailErr("Please enter a valid email address");
        setLoader(false);
      } else if (!isPasswordValid) {
        setPasswordErr("Password is required");
        setLoader(false);
      }
    } catch (err) {
      console.error(err);
      setLoader(false);
      setErrMsg("Something went wrong");
    }
  };

  const submitForm = async e => {
    e.preventDefault();
    if (e.keyCode === 13) {
      executeCaptcha(e);
    }
  };

  const emailChange = value => {
    setUserEmail(value?.trim()?.toLowerCase() || "");
    setEmailErr("");
    setErrMsg("");
  };

  const passwordChange = valueObj => {
    setUserPassword(valueObj);
    setPasswordErr("");
    setErrMsg("");
  };

  const executeCaptcha = e => {
    e && Utils.removeInputRequired(e);
    let isEmailValid = Utils.emailValidate(userEmail?.trim() || "");
    let isPasswordValid = userPassword?.password;
    if (isEmailValid && isPasswordValid) {
      setLoader(true);
      captchaStoreValue.executeCaptcha(validateCaptchaFromAPi);
    } else if (!isEmailValid) {
      setEmailErr("Please enter a valid email address");
      setLoader(false);
    } else if (!isPasswordValid) {
      setPasswordErr("Password is required");
      setLoader(false);
    }
  };

  const validateCaptchaFromAPi = async token => {
    token && login(token);
  };

  const inputBoxObjList = [
    {
      name: "workEmail",
      id: "workEmail",
      type: "email",
      value: userEmail,
      changeAction: emailChange,
      keyupAction: submitForm,
      errMsg: emailErr,
      label: "Work Email",
      isPassword: false,
      placeholder: `eg: john@salesgear.io`,
      focus: true,
    },
    {
      name: "password",
      id: "password",
      type: "password",
      value: userPassword,
      changeAction: value =>
        passwordChange({ ...userPassword, password: value }),
      keyupAction: submitForm,
      errMsg: passwordErr || errMsg,
      label: "Password",
      className: "password",
      isPassword: true,
      placeholder: "Password",
      showPasswordAction: () =>
        setUserPassword({
          ...userPassword,
          showPassword: !userPassword?.showPassword,
        }),
    },
  ];

  useEffect(() => {
    alertStore.setShowStatusPopup(false);
    Utils.mixpanelTrack(MP_EVENT.LOGIN_VISITED, {
      pageType: "Login",
    });
  }, []);

  useEffect(() => {
    const handleLoginSuccess = async () => {
      if (authPopupRef.current && !authPopupRef.current.closed) {
        authPopupRef.current.close();
      }
      await loginValidate();
      if (pluginUser) {
        props.history.push(`/pluginSuccess${location.search}`);
      } else if (homeRouteUser) {
        props.history.push("/pricing");
      } else {
        window.top.location.href = "/dashboard";
      }
    };

    const onMessage = event => {
      const { data = "" } = event;
      if (data?.type === "WEB_GOAUTH_LOGIN_ACCESS") {
        handleLoginSuccess();
      }
    };

    window.addEventListener("message", onMessage);

    let bc;
    if (typeof BroadcastChannel !== "undefined") {
      bc = new BroadcastChannel("google_auth");
      bc.onmessage = event => {
        if (event.data?.type === "WEB_GOAUTH_LOGIN_ACCESS") {
          handleLoginSuccess();
        } else if (event.data?.type === "GOOGLE_OUTH_ERR") {
          if (authPopupRef.current && !authPopupRef.current.closed) {
            authPopupRef.current.close();
          }
          window.postMessage(event.data, "*");
        }
      };
    }

    return () => {
      window.removeEventListener("message", onMessage);
      if (bc) bc.close();
    };
  }, []);

  useEffect(() => {
    const handleAlertBox = e => {
      const { data = "" } = e;
      const { type = "", message = "", msgType = "", popupState = false } = data;
      if (type === "GOOGLE_OUTH_ERR") {
        alertStore.setShowStatusPopup(popupState);
        alertStore.setAlertMessage(message, msgType);
      }
    };
    window.addEventListener("message", handleAlertBox);
    return () => {
      window.removeEventListener("message", handleAlertBox);
    };
  }, []);

  return (
    <section
      className={`formInputBox ${loader ? "pointerUserSelectNone" : ""}`}
    >
      <h3>Welcome Back!</h3>
      <div className="googleLoginBtn">
        <button
          type="button"
          className="signInWithGoogleBtn"
          onClick={() => {
            alertStore.setShowStatusPopup(false);
            const w = 600, h = 800;
            const left = window.screen.width / 2 - w / 2;
            const top = window.screen.height / 2 - h / 2;
            const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${w},height=${h},left=${left},top=${top}`;
            const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?scope=email%20profile&access_type=offline&include_granted_scopes=true&response_type=code&redirect_uri=${encodeURIComponent(`${CLIENT_URL}/connect/gAuth/callback`)}&client_id=${GOOGLE_CLIENT_ID}&state=LOGIN`;
            authPopupRef.current = window.open(authUrl, "Salesgear", params);
          }}
        >
          <img src={GoogleImg} alt="Google" />
          Continue with Google
        </button>
      </div>
      <AlertBox />
      <div className="signupSeparator">OR</div>
      <form autoComplete="on" id="loginform">
        {inputBoxObjList.map(item => (
          <InputBox {...item} key={item.id} />
        ))}
      </form>
      <div className="forgotPasswordLink">
        <Link to={`/forgotPassword?${queryParams?.toString()}`}>
          Forgot Password?
        </Link>
      </div>
      <Button
        id="loginBtn"
        name="loginBtn"
        btnText="Log In"
        className={
          loader
            ? "loading"
            : "loginBtn btn-new btn-rounded btn-orange btn-text btn-arrow"
        }
        loader={loader}
        type="button"
        click={e => {
          e.preventDefault();
          executeCaptcha(e);
        }}
      />
    </section>
  );
});

export default withRouter(LoginComponent);
